import {IBaseEntity, BaseEntity} from 'app/blocks/model/base-entity.model';

export interface IBookIn extends IBaseEntity {
    id: number;
    bookedInWith: string;
    bookedInReferences: string;
    bookedInDateTime: Date;
    deviationReasonId: number;
    bookedInBy: string;
}

export class BookIn extends BaseEntity implements IBookIn {
    public id: number;
    public bookedInWith: string;
    public bookedInReferences: string;
    public bookedInDateTime: Date;
    public deviationReasonId: number;
    public bookedInBy: string;

    constructor(bookIn?) {
        super();
        if (bookIn) {
            this.id = bookIn.id;
            this.bookedInWith = bookIn.bookedInWith;
            this.bookedInReferences = bookIn.bookedInReferences;
            this.bookedInDateTime = bookIn.bookedInDateTime;
            this.deviationReasonId = bookIn.deviationReasonId;
            this.bookedInBy = bookIn.bookedInBy;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): BookIn {
        return new BookIn(this);
    }
}
